import styled from "styled-components";

/* Header container style */
export const HeaderWrapper = styled.div`
  max-width: 100%;
  background-color: ${(props) => props.theme.background_white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 10vh;
  font-family: "Poppins";
  box-shadow: 1px 8px 5px -3px rgba(67,59,59,0.75);
-webkit-box-shadow: 1px 8px 5px -3px rgba(67,59,59,0.75);
-moz-box-shadow: 1px 8px 5px -3px rgba(67,59,59,0.75);
  
`;
/* LOGO CONTAINER STYLE */
export const LogoWrapper = styled.div`
  width: 70px;
  height: 3.5;
  margin-left: 3rem;
  vertical-align: center;

  @media screen and (max-width: 450px) {
    margin-left: 5px;
    width: 50px;
    height: 50px;
  }
`;
/* Logo Image style */
export const Logo = styled.img`
  width: 100%;
  height: 100%;
  image-resolution: from-image;
`;
/* Nav Links Style */
export const NavLinksWrap = styled.div`
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  margin-right: 3rem;
  .header_nav {
    font-weight: 400;
    margin: 0 20px;
    color: #000000;
    opacity: 0.8;
    font-size: 12px;
    line-height: 22px;
    @media screen and (max-width: 450px) {
      margin: 0 10px;
    }
  }
  @media screen and (max-width: 450px) {
    margin-left: 7px;
  }
`;
export const SignUpButton = styled.button`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color:  #FFFFFF;
  cursor: pointer;
  background: #3E6D74;
  opacity: 0.8;
  border: 0;
  border-radius: 30px;
  line-height: 22px;
  letter-spacing: 1.5;
  transition: hover 0.2s ease-in-out;
  white-space: nowrap;
  width: 100px;
  &:focus{
    outline: 0;
  }
  @media screen and (max-width: 600px){
    width: 70px;
  }
 
 
`;
export const LogINButton = styled.button`
  font-size: 12px;
  background: transparent;
  border: 1px solid #3E6D74;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0.8;
  line-height: 22px;
  letter-spacing: 1.5;
  transition: hover 0.2s ease-in-out;
  border-radius: 30px;
  width: 100px;
  margin: 0px 5px;
  word-wrap: none;
  color: #3E6D74;
  white-space: nowrap;

  &:focus{
    outline: 0;
  }
  
  @media screen and (max-width: 600px){
    width: 70px;
  }
 
`
export const UserPhotoWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 4px;
  border: 2px solid #6a6a6a;
`;
export const UserPhoto = styled.img`
  object-position: bottom;
  object-fit: cover;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
`;

/* Drawer design */
export const DrawerTabWrapper = styled.div`
  width: 100%;
  height: 100%;

  

  ul{
    width: 100%;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    white-space: nowrap;

    li{
      margin: 20px 0px;
      display: flex;
      align-items: center;
      /* justify-content: space-between; */
      max-width: 120px;
      opacity: .8;
      cursor: pointer;
      font-weight: 600;
      color: #000000;
      svg{
        margin-right: 5px;
      }
      
      
    }
    .drawerLink{
      color: #000000;
    }
    
  }
`